import type { HsCameraType } from '../../engine-new/enums/camera-type.enum';
import { HsControlActionType } from './control-action-type.enum';
import { HsControlAction } from './control-action.abstract';

export class HsCameraTypeControlAction extends HsControlAction {
  public readonly actionType: HsControlActionType = HsControlActionType.CameraType;
  constructor(public cameraType: HsCameraType) {
    super();
  }

  public getValuesFrom(controlAction: HsControlAction): void {
    if (!(controlAction instanceof HsCameraTypeControlAction)) {
      return;
    }

    this.cameraType = controlAction.cameraType;
  }
}
